import { render, staticRenderFns } from "./Resource-mobile.vue?vue&type=template&id=e59b06d4&scoped=true"
import script from "./Resource-mobile.vue?vue&type=script&lang=js"
export * from "./Resource-mobile.vue?vue&type=script&lang=js"
import style0 from "./Resource-mobile.vue?vue&type=style&index=0&id=e59b06d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59b06d4",
  null
  
)

export default component.exports